// extracted by mini-css-extract-plugin
module.exports = {"checkCircle":"src-components-UI-CheckCircle-styles-style-module__checkCircle--26buc"};